export default __webpack_public_path__ + "static/media/LAST.555382e6cb2e95c38281467742d9b3ad.webp";